// Queries de LOTE_NAVE.

import { apiFetch, qk, useApiMutation, useApiQuery } from './client';
import type { LoteNave } from '@/lib/types';

const LOTES_KEY = qk('lotes-nave');

export function useLotesDeCamada(camadaId: number | null) {
  return useApiQuery<LoteNave[]>({
    queryKey:
      camadaId != null ? [...LOTES_KEY, 'camada', camadaId] : qk('lotes-nave', 'camada', 'none'),
    queryFn: () => apiFetch<LoteNave[]>(`/v1/camadas/${camadaId}/lotes-nave`),
    enabled: camadaId != null,
    staleTime: 30 * 1000,
  });
}

/** Crea un lote. Devuelve el lote creado. */
export function useCrearLote(camadaId: number) {
  return useApiMutation<{ nave_id: number; num_animales_asignados: number }, LoteNave>({
    mutationFn: (body, context) =>
      apiFetch<LoteNave>(`/v1/camadas/${camadaId}/lotes-nave`, {
        offlineBase: context.offlineBase,
        method: 'POST',
        body: JSON.stringify(body),
      }),
    invalidateKeys: [LOTES_KEY, qk('camadas'), qk('liquidacion-evolucion')],
  });
}

/** Corrige la cantidad conservando la asignación física y su identificador. */
export function useEditarLote(camadaId: number) {
  return useApiMutation<{ id: number; num_animales_asignados: number }, LoteNave>({
    mutationFn: ({ id, num_animales_asignados }, context) =>
      apiFetch<LoteNave>(`/v1/camadas/${camadaId}/lotes-nave/${id}`, {
        offlineBase: context.offlineBase,
        method: 'PATCH',
        body: JSON.stringify({ num_animales_asignados }),
      }),
    invalidateKeys: [LOTES_KEY, qk('camadas'), qk('liquidacion-evolucion')],
  });
}
